<div class="label-bar">
  @for (energyLabel of energyLabels(); track $index) {
    <div
      class="label"
      [title]="energyLabel.translation"
      [class]="energyLabel.colorClass"
      [style.flex]="energyLabel.percentage + '%'"
    >
      @if (showLabel()) {
        <strong>{{ energyLabel.label }}</strong
        >&nbsp;{{ energyLabel.percentage }}%
      } @else {
        <strong>{{ energyLabel.percentage }}%</strong>
      }
    </div>
  }
</div>
